import React, { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { formatNumber } from 'store/actions/mainPage/constant';
import { PieDiagram } from 'components/PieTab/PieDiagram';
import {
  setBackdropLoadingAction,
  setExportingStatsAction,
} from 'store/actions/mainPage';
import { ExportStatProps } from 'types/mainPage';
import { exportDataLog, exportFile } from 'utils/exportFile';
import { Box, Typography } from '@mui/material';

export const PieForExport: React.FC<ExportStatProps> = ({ setOpen }) => {
  const {
    statisticsData,
    isLogged,
    exportingStats: exporting,
    exportingExt: ext,
    lang,
  } = useAppSelector((state) => state.mainPage);
  const pieRef = useRef(null);
  const dispatch = useAppDispatch();

  if (!statisticsData) {
    return null;
  }

  useEffect(() => {
    const { filename: fileTitle } = statisticsData.export;

    setTimeout(() => {
      exportFile(pieRef.current, fileTitle, ext)
        .then(() => exportDataLog(isLogged, fileTitle, ext, 'diagrams'))
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          dispatch(setExportingStatsAction(false, ''));
        });
    }, 800);

    return () => {
      dispatch(setBackdropLoadingAction(false));
      setOpen(false);
    };
  }, [exporting]);

  const fz =
    window.innerWidth > 5000
      ? '8.5rem'
      : window.innerWidth > 2700
      ? '3.5rem'
      : '1.5rem';

  const pieWidth = window.innerHeight / 2;

  return (
    <Box
      ref={pieRef}
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'start',
        position: 'fixed',
        left: '-9999px',
        top: '-9999px',
      }}
    >
      <Box
        id="pie-diagram"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <PieDiagram
          height={pieWidth}
          width={pieWidth}
          fz={fz}
          animateRotate={false}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            mt: 1,
            p: 4,
            pr: 2,
            flex: 1,
            width: pieWidth * 1.5,
          }}
        >
          {statisticsData.data.map((item: any) => {
            return (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 1,
                  minWidth: 350,
                }}
                key={item.id}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: fz,
                      height: fz,
                      mr: 1,
                      backgroundColor: item.color,
                      border: '1px solid black',
                    }}
                  />
                  <Typography sx={{ fontSize: fz }}>
                    {item.paramName}
                  </Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: fz }}>
                    {formatNumber(item.paramValue, lang)}{' '}
                    {statisticsData?.export.unit}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
